import { handleActions } from 'redux-actions';

export const PAYMENT_REQUEST_API_ACTION = 'CHECKOUT/PAYMENTREQUESTAPI/SET';

export const reducer = handleActions(
  {
    [PAYMENT_REQUEST_API_ACTION]: (_, action) => action.payload,
  },
  {
    support: false,
    request: {} as PaymentRequest,
  },
);

export default reducer;
